import React from "react";

import titlePic from "../../../assets/images/square.jpg";
import "./TitlePicture.css";

const titlePicture = () => (
  <div className="TitlePicture">
    <img src={titlePic} alt="Me with a teddy bear :)" />
  </div>
);

export default titlePicture;
